<div id="print-section"
     style="width:100%; font-family:Arial; font-size:12px; border:1px solid black; ">

  <!-- HEADER -->
  <table style="width:100%; border-bottom:2px solid black; ">
    <tr>
      <td style="width:31%; text-align:left; font-weight:bold; font-size:16px;">
        हिंदुस्तान प्रकाशन संस्था
      </td>

      <td style="width:28%; text-align:center; font-weight:bold; font-size:18px;">
        Business Report
      </td>

      <td style="width:40%; text-align:right; font-weight:bold;font-size:16px;">
        दिनांक : {{ today | date:'dd-MM-yyyy' }}
      </td>
    </tr>

    <tr>
      <td style="text-align:left; font-weight:bold;font-size:16px;">
        विवेक पुस्तक प्रकाशन
      </td>

      <td style="text-align:center; font-weight:bold;font-size:16px;">
        BookWise
      </td>

      <td style="text-align:right; font-weight:bold;font-size:16px;">
        From {{ startDate | date:'dd-MM-yyyy' }}
        To {{ endDate | date:'dd-MM-yyyy' }}
      </td>
    </tr>
  </table>

  <!-- TABLE -->
  <table style="width:100%; border-collapse:collapse; table-layout:fixed;" >

    <!-- HEADER -->
    <thead style="background:#f5c518;">
      <tr>
        <!-- <th style="width:90px;">Month</th> -->
        <th style="width:50px;">अ.क्र.</th>
        <th style="width:200px;">Book Name</th>
        <th>बिलींग</th>
        <th>क्रेडीट</th>
        <th>येणे</th>
        <th>बाकी</th>
      </tr>
    </thead>

    <!-- BODY -->
    <tbody>

      <ng-container *ngFor="let month of months">

        <!-- Month Row -->
        <tr style="background:#ddd; font-weight:bold;">
          <td colspan="6" style="text-align:center; padding-left:5px;">
            {{ month.month }}
          </td>
        </tr>

        <!-- Data Rows -->
        <tr *ngFor="let row of month.rows; let i = index">
          <!-- <td></td> -->
          <td style="text-align:center;">{{ i + 1 }}</td>
          <td style="text-align:left;">{{ row.book_name }}</td>
          <td style="text-align:right;">{{ row.total_billing_amt  }}</td>
          <td style="text-align:right;">{{ row.paid_amt }}</td>
          <td style="text-align:right;">{{ row.credit_amt  }}</td>
          <td style="text-align:right;">{{ row.unpaid_amt  }}</td>
        </tr>

        <!-- Month Total -->
        <tr style="background:#eee; font-weight:bold;">
          <td colspan="2" style="text-align:right;">Total</td>
          <td style="text-align:right;">{{ month.total_billing_amt }}</td>
          <td style="text-align:right;">{{ month.total_paid_amt }}</td>
          <td style="text-align:right;">{{ month.total_credit_amt  }}</td>
          <td style="text-align:right;">{{ month.total_unpaid_amt  }}</td>
        </tr>

      </ng-container>

    </tbody>

    <!-- FOOTER -->
    
      <tr>
        <td colspan="2" style="text-align:right;background:#c8753f; font-weight:bold;">Grand Total</td>
        <td style="text-align:right;background:#c8753f; font-weight:bold;">{{ grandTotal.total_billing_amt  }}</td>
        <td style="text-align:right;background:#c8753f; font-weight:bold;">{{ grandTotal.total_paid_amt }}</td>
        <td style="text-align:right;background:#c8753f; font-weight:bold;">{{ grandTotal.total_credit_amt }}</td>
        <td style="text-align:right;background:#c8753f; font-weight:bold;">{{ grandTotal.total_unpaid_amt }}</td>
      </tr>
  

  </table>

  <!-- BUTTONS -->
  <!-- <div style="text-align:center; margin-top:10px;" class="noPrint">
    <button (click)="exportExcel('Bookwise_Report')">Export</button>
    <button (click)="printReportA4Landscape()">Print</button>
  </div> -->
  <button mat-raised-button color="primary"
            (click)="exportExcel('Book_InDetail_Officewise')">
      📊 Export
    </button>

    <button mat-raised-button color="accent"
            (click)="printPageA4()">
      🖨️ Print
    </button>

    <button mat-button mat-dialog-close>
      ❌ Close
    </button>

</div>